import React from 'react';
import {debounce} from 'ts-debounce';

import {MIN_QUERY_LENGTH, SHORT_QUERY_MESSAGE} from 'search/SearchConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import PlainSearchInput from 'ui-library/PlainSearchInput';
import {InputChangeEvent} from 'util/Types';

const DEBOUNCE_MS = 250;
interface Props {
  inputIcons?: Array<JSX.Element>;
  onUpdateQuery: (query: string) => void;
  query: string;
  placeholder?: string;
  disabled?: boolean;
}

interface State {
  query: string;
}

class QueryInput extends React.Component<Props, State> {
  private doUpdateQueryDebounced: () => void;

  constructor(props: Props) {
    super(props);
    this.state = {query: props.query};
    this.doUpdateQueryDebounced = debounce(this._handleUpdateQuery, DEBOUNCE_MS);
  }

  override UNSAFE_componentWillReceiveProps = (nextProps: Props): void => {
    if (this.props.query !== nextProps.query) {
      this.setState({query: nextProps.query});
    }
  };

  _handleUpdateQuery = (): void => {
    this.props.onUpdateQuery(this.state.query);
  };

  _handleChange = (e: InputChangeEvent): void => {
    if (this.state.query !== e.target.value) {
      this.setState({query: e.target.value});
      this.doUpdateQueryDebounced();
    }
  };

  override render(): JSX.Element {
    const tooltipTitle =
      this.state.query.length > 0 && this.state.query.length < MIN_QUERY_LENGTH ? SHORT_QUERY_MESSAGE : '';
    return (
      <Tooltip title={tooltipTitle} trigger="manual" open={tooltipTitle !== ''}>
        <PlainSearchInput
          className="u-flex-grow"
          placeholder={this.props.placeholder ?? 'Search'}
          value={this.state.query}
          onChange={this._handleChange}
          additionalIcons={this.props.inputIcons}
          disabled={this.props.disabled}
        />
      </Tooltip>
    );
  }
}

export default QueryInput;
